module.exports = __webpack_public_path__ + "img/ipad.4c039d8f.png";